import { render, staticRenderFns } from "./SpecCell.vue?vue&type=template&id=0f051f75&scoped=true&lang=pug&"
import script from "./SpecCell.vue?vue&type=script&lang=js&"
export * from "./SpecCell.vue?vue&type=script&lang=js&"
import style0 from "./SpecCell.vue?vue&type=style&index=0&id=0f051f75&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f051f75",
  null
  
)

export default component.exports